<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Store</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <input-select
              name="status"
              placeholder="Select a store to create"
              class="m-0"
              :options="typeOptions"
              @input="value => selectStore(value)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div v-if="form.type && form.type != null" class="col-md-12 col-sm-12">
              <form class="form-horizontal" @submit.prevent="() => {}">
                <div class="form-group">
                  <input-text
                    type="text"
                    name="name"
                    label="Name"
                    placeholder="Name"
                    :value="form.name"
                    :errors="error.name"
                    :required="true"
                    @input="value => setField({ key: 'name', value })"
                    v-if="form.type !== 'shopify'"
                  />
                </div>

                <div v-if="form.type == 'woocommerce'">
                  <div class="form-group">
                    <input-text
                      type="text"
                      name="url"
                      label="Site URL"
                      placeholder="https://yoursite.com"
                      :value="form.url"
                      :errors="error.url"
                      :required="true"
                      @input="value => setField({ key: 'url', value })"
                    />
                  </div>
                </div>

                <div v-if="form.type == 'shopify'">
                  <h4>Install Instruction</h4>
                  <div class="mb-3">
                    <div>
                      <p>Step 1: Open <b>PrintHigh POD Fulfillment</b> on <b>Shopify App Store</b></p>
                      <img class="img-fluid w-50 my-3" src="/images/shopify-install.png" />
                      <p>Step 2: Click <b>Add App</b> and follow the instruction</p>
                      <p>Step 3: Create new products</p>
                      <p>Step 4: Wait for new orders</p>
                      <p>Step 5: Wait for us to do the rest</p>
                    </div>
                  </div>
                </div>
                
                <div v-if="form.type == 'self_app_etsy'">
                  <div class="form-group">
                    <input-text
                      type="text"
                      name="apiKey"
                      label="API Key"
                      :value="form.apiKey"
                      :errors="error.apiKey"
                      :required="true"
                      @input="value => setField({ key: 'apiKey', value })"
                    />
                    <input-text
                      type="text"
                      name="apiSecret"
                      label="API Secrect"
                      :value="form.apiSecret"
                      :errors="error.apiSecret"
                      :required="true"
                      @input="value => setField({ key: 'apiSecret', value })"
                    />
                  </div>
                </div>

                <div v-if="form.type == 'amazon_seller_central'">
                  <div>
                    <ol>
                      <li>Log in <a target="_blank" href="https://sellercentral.amazon.com/apps/manage/">here</a> to access the Manage Your Apps page in Amazon Seller Central</li>
                      <li>Click <b>Authorize new developer</b></li>
                      <li>
                        Enter the following developer inforation, then click <b>Next</b>.<br/><br/>
                        <b>Developer Name:</b> ShipStation<br/>
                        <b>Developer Account No:</b> 4289-4417-4486<br/>
                      </li>
                      <li>Follow the prompts, then copy the <b>Seller ID</b> and <b>MWS Auth Token</b> into the fields below.</li>
                    </ol>
                  </div>
                  <div class="form-group">
                    <input-text
                      type="text"
                      name="amazonSellerId"
                      label="Amazon Seller ID"
                      placeholder=""
                      :value="form.amazonSellerId"
                      :errors="error.amazonSellerId"
                      :required="true"
                      @input="value => setField({ key: 'amazonSellerId', value })"
                    />
                    <input-text
                      type="text"
                      name="mwsAuthToken"
                      label="MWS Auth Token"
                      placeholder=""
                      :value="form.mwsAuthToken"
                      :errors="error.mwsAuthToken"
                      :required="true"
                      @input="value => setField({ key: 'mwsAuthToken', value })"
                    />
                  </div>
                </div>

                <form-button
                  type="primary"
                  input-type="button"
                  :disabled="loading"
                  :loading="loading"
                  text="CREATE"
                  :click="() => createStore()"
                  v-if="form.type !== 'shopify'"
                />
              </form>
            </div>
            <div v-else>
              Please select a store to create!
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";

  import InputSelect from "@/components/Form/InputSelect";
  import InputText from "@/components/Form/InputText";
  import Pagination from "@/components/Misc/Pagination";
  import LinkButton from "@/components/Misc/LinkButton";
  import FormButton from "@/components/Form/FormButton";
  import Breadcrumb from "@/components/Common/Breadcrumb";

  export default {
    name: "CreateStore",
    components: {
      InputSelect,
      Pagination,
      LinkButton,
      InputText,
      FormButton,
      Breadcrumb
    },
    beforeMount() {
      this.clearForm();
    },
    computed: {
      ...mapGetters({
        loading: "store/loading",
        typeOptions: 'store/displayTypeOptions',
        form: "store/form",
        error: 'store/error',
      }),
      currentPage() {
        return this.$store.state.route.meta.title;
      }
    },
    methods: {
      ...mapActions({
        setField: "store/setField",
        createStore: "store/createStore",
        clearForm: "store/clearForm",
      }),
      selectStore(store) {
        this.setField({ key: 'type', value: store });
      },
    }
  };
</script>
